function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendArticle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9049"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8062"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3137",
    d: "m641.59 375.8 2.444-1.512.477-.3h7.933a4.939 4.939 0 0 0 4.932-4.933v-3.946a4.939 4.939 0 0 0-4.932-4.934h-5.921a4.94 4.94 0 0 0-4.933 4.934V375.8m-1.973 3.541v-14.23a6.907 6.907 0 0 1 6.906-6.907h5.921a6.907 6.907 0 0 1 6.906 6.907v3.946a6.906 6.906 0 0 1-6.906 6.906h-7.372z",
    transform: "translate(-637.483 -356.771)",
    style: {
      fill: "#175664"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3138",
    d: "M653.069 366.178H646.6a.987.987 0 0 1 0-1.973h6.466a.987.987 0 0 1 0 1.973z",
    transform: "translate(-637.563 -356.851)",
    style: {
      fill: "#175664"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3139",
    d: "M649.563 370.178H646.6a.987.987 0 0 1 0-1.973h2.96a.987.987 0 0 1 0 1.973z",
    transform: "translate(-637.563 -356.905)",
    style: {
      fill: "#175664"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendArticle);
export default __webpack_public_path__ + "static/media/sendArticle.28fcdeed.svg";
export { ForwardRef as ReactComponent };